import { render, staticRenderFns } from "./InputFormTextInquiry.vue?vue&type=template&id=0395c65e&"
import script from "./InputFormTextInquiry.vue?vue&type=script&lang=ts&"
export * from "./InputFormTextInquiry.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports